//实际处理方法
import {removeToken} from '../utils/auth.js'
export default{
	
	
	initSystemData(state,obj){
		state.systemData = obj
	},
	Login(state,obj){
		state.Login = obj
	},
	SetQuery(state,obj){
		state.Query = obj
	},
	LogOut(state,obj){
		state.Login = {}
		removeToken()
	},
	SetSearch(state,obj){
		state.Search = obj
	}
}